import * as React from "react";
import type { SVGProps } from "react";
const SvgNoInvoiceDetails = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={46}
    height={56}
    fill="none"
    viewBox="0 0 46 56" {...props}
  >
    <g clipPath="url(#no-invoice-details_svg__a)">
      <path
        fill="url(#no-invoice-details_svg__b)"
        d="M43.456 56H13.952c-1.239 0-2.241-1.02-2.241-2.28V17.063h31.728c1.414 0 2.561 1.166 2.561 2.605V53.41c0 1.429-1.14 2.587-2.544 2.587z"
        opacity={0.56}
      />
      <path
        fill="#fff"
        stroke="#00217B"
        strokeMiterlimit={10}
        d="m39.471 52.453-30.365-.349c-1.365-.015-2.46-1.154-2.445-2.542l.44-39.62c.017-1.535 1.253-2.764 2.762-2.746l23.36.267c1.099.013 2.146.47 2.913 1.268l5.154 5.365a4.6 4.6 0 0 1 1.276 3.24l-.36 32.392c-.017 1.523-1.243 2.742-2.74 2.724z"
      />
      <path
        stroke="#00217B"
        strokeMiterlimit={10}
        d="M32.833 25.789c0 4.673-3.929 8.46-8.776 8.46s-8.775-3.787-8.775-8.46 3.929-8.46 8.775-8.46"
      />
      <path
        stroke="#00217B"
        strokeMiterlimit={10}
        d="m22.129 19.746 2.377-2.56-2.936-1.848"
      />
      <path
        fill="url(#no-invoice-details_svg__c)"
        d="M38.61 38.766H11.064v2.487H38.61z"
      />
      <path
        fill="url(#no-invoice-details_svg__d)"
        d="M38.61 42.849H17.432v2.247H38.61z"
      />
      <path
        fill="#FFCE00"
        d="M8.343 16.977c4.608 0 8.344-3.8 8.344-8.489C16.687 3.8 12.95 0 8.343 0S0 3.8 0 8.488s3.735 8.489 8.343 8.489"
      />
      <path
        fill="#0D0D48"
        d="M7.473 10.15v-.083q.008-.819.161-1.303a1.96 1.96 0 0 1 .44-.783q.285-.299.687-.545.258-.168.466-.374.209-.205.328-.474.12-.27.121-.594 0-.391-.18-.676a1.26 1.26 0 0 0-.482-.442 1.4 1.4 0 0 0-.668-.157q-.332 0-.635.142-.303.14-.501.436t-.229.763H5.666q.03-.792.395-1.34.364-.55.962-.829.6-.282 1.326-.283.796 0 1.392.3c.397.203.707.48.928.842q.33.538.33 1.254 0 .493-.151.887a2.2 2.2 0 0 1-.43.702q-.28.306-.667.545a2.8 2.8 0 0 0-.596.485 1.54 1.54 0 0 0-.33.593c-.07.227-.107.513-.112.848v.084H7.478zm.655 2.676a.83.83 0 0 1-.61-.257.85.85 0 0 1-.256-.624c0-.245.084-.447.255-.618a.83.83 0 0 1 .61-.258c.24 0 .438.086.609.258a.85.85 0 0 1 .258.618q0 .242-.12.442a.9.9 0 0 1-.312.318.8.8 0 0 1-.432.119z"
      />
    </g>
    <defs>
      <linearGradient
        id="no-invoice-details_svg__b"
        x1={28.854}
        x2={28.854}
        y1={-7.153}
        y2={74.355}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.19} stopColor="#228FE6" />
        <stop offset={0.45} stopColor="#1AA0E0" />
        <stop offset={0.74} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
      <linearGradient
        id="no-invoice-details_svg__c"
        x1={43.005}
        x2={5.015}
        y1={39.576}
        y2={40.449}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="no-invoice-details_svg__d"
        x1={41.993}
        x2={12.778}
        y1={43.639}
        y2={44.31}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <clipPath id="no-invoice-details_svg__a">
        <path fill="#fff" d="M0 0h46v56H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNoInvoiceDetails;
